import { RootState } from "../../reducers";
import { Notification } from "./types";

export const notificationSelector = (state: RootState): Notification | null =>
  state.notifications.notification;
